import React, { Component } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Checkbox,
    Typography,
    Box,
    Grid,
    Button,
    CircularProgress,
    Autocomplete,
    TextField
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

import { apiUrl } from '../../comp/ApiUrl';
import InspectorCelular from '../ChecklistNew/InspectorCelular';
import PrintIcon from '@mui/icons-material/Print';
import { WithRouter } from '../../comp/WithRouter';

class ChecklistView extends Component {
    constructor(props) {
        super(props);

        this.clientesMock = [
            { id: 1, nome: "João Silva", documento: "123.456.789-00" },
            { id: 2, nome: "Maria Oliveira", documento: "987.654.321-11" },
            { id: 3, nome: "Carlos Souza", documento: "456.123.789-22" }
        ];

        this.state = {
            componentes: [],
            checklist: {}, // Armazena os estados (SIM, NAO, NA) de cada item
            loader: true,
            enviando: false,
            store: {},
            clienteSelecionado: null,
            os: '',
            aparelho: '',
            imei: ''
        };
    }

    componentDidMount() {

        fetch(`${apiUrl}/checklist/entry/${this.props.params.uuid}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(resp => {
            if (resp.ok) {
                resp.json().then(data => {

                    const checklistDados = JSON.parse(data.checklist.checklist_tabela || '{}');
                    const componentes = Object.keys(checklistDados);

                    let checklistFormatado = {};
                    componentes.forEach(item => {
                        if (checklistDados[item] === true) {
                            checklistFormatado[item] = 'SIM';
                        } else if (checklistDados[item] === false) {
                            checklistFormatado[item] = 'NAO';
                        } else {
                            checklistFormatado[item] = 'NA';
                        }
                    });

                    let cliente = this.clientesMock.find(c => c.id === data.cliente_id) || {
                        id: data.cliente_id,
                        nome: data.checklist.cliente_nome,
                        documento: data.checklist.cliente_documento
                    };

                    this.setState({
                        store: data.store,
                        componentes: componentes,
                        checklist: checklistFormatado,
                        clienteSelecionado: cliente,
                        aparelho: data.checklist.aparelho || '',
                        os: data.checklist.os || '',
                        imei: data.checklist.imei || '',
                        loader: false
                    });

                });
            }
        }).catch(err => {
            console.error("Erro ao buscar dados:", err);
            this.setState({ loader: false });
        });
    }

    handleCheckboxChange = (item, valor) => {
        this.setState(prevState => ({
            checklist: {
                ...prevState.checklist,
                [item]: prevState.checklist[item] === valor ? 'NA' : valor
            }
        }));
    };

    // Função responsável por gerar a janela de impressão idêntica à imagem
    handlePrint = () => {
        // Captura todas as variáveis do estado para preencher o documento
        const {
            store,
            checklist,
            componentes,
            clienteSelecionado,
            aparelho,
            imei,
            osNumero, // Puxa o número real da O.S. do seu sistema
            dadosLoja // Puxa os dados cadastrados da sua loja
        } = this.state;

        // Fallback caso os dados da loja ou OS não estejam no estado (evita quebrar o código)
        const loja = dadosLoja || {
            nome: this.props.user.store_name,
            cnpj: "00.000.000/0001-00",
            endereco: "Rua Principal, 123 - Centro",
            telefone: "(11) 99999-9999",
            email: "contato@suportesmart.com.br"
        };
        const numeroOS = osNumero || "0001";

        const printWindow = window.open('', '_blank', 'width=900,height=1200');

        // Monta as linhas da tabela de checklist de forma dinâmica
        const totalLinhas = componentes.map(item => `
            <tr>
                <td class="componente-nome">✓ ${item}</td>
                <td class="center">${checklist[item] === 'SIM' ? 'X' : ''}</td>
                <td class="center">${checklist[item] === 'NAO' ? 'X' : ''}</td>
                <td class="center">${checklist[item] === 'NA' || !checklist[item] ? 'X' : ''}</td>
            </tr>
        `).join('');

        printWindow.document.write(`
            <html>
            <head>
                <title>Ordem de Serviço #${this.state.os} - ${loja.nome}</title>
                <style>
                    @page { size: A4 portrait; margin: 8mm; }
                    body { font-family: Arial, sans-serif; font-size: 10px; margin: 0; padding: 0; color: #000; line-height: 1.2; }
                    
                    /* Cabeçalho Estruturado e Alinhado */
                    .header-loja { display: table; width: 100%; border: 2px solid #000; margin-bottom: 5px; box-sizing: border-box; }
                    .logo-box { display: table-cell; width: 75px; height: 75px; vertical-align: middle; text-align: center; font-weight: bold; font-size: 11px; border-right: 2px solid #000; background: #fafafa; }
                    .info-loja { display: table-cell; vertical-align: middle; padding: 5px 12px; }
                    .info-loja h1 { margin: 0 0 3px 0; font-size: 18px; text-transform: uppercase; font-weight: bold; letter-spacing: 0.5px; }
                    .info-loja p { margin: 2px 0; font-size: 9.5px; color: #222; }
                    .os-box { display: table-cell; width: 150px; vertical-align: middle; text-align: center; border-left: 2px solid #000; background: #f5f5f5; }
                    .os-box h2 { margin: 0; font-size: 11px; font-weight: bold; letter-spacing: 0.5px; }
                    .os-numero { font-size: 24px; font-weight: bold; margin-top: 3px; color: #000; }
    
                    /* Informações do Cliente e Aparelho */
                    .info-cliente { border: 2px solid #000; padding: 6px 8px; margin-bottom: 5px; box-sizing: border-box; background: #fff; }
                    .info-grid { display: table; width: 100%; }
                    .info-row { display: table-row; }
                    .info-cell { display: table-cell; padding: 3px 0; font-size: 10.5px; }
                    .info-cell strong { font-weight: bold; }
    
                    /* Layout de Duas Colunas (Checklist vs Condições/Termos) */
                    .container-flex { display: table; width: 100%; table-layout: fixed; box-sizing: border-box; }
                    .col-esquerda { display: table-cell; width: 43%; vertical-align: top; padding-right: 3px; }
                    .col-direita { display: table-cell; width: 57%; vertical-align: top; padding-left: 3px; }
    
                    .titulo-secao { text-align: center; font-weight: bold; font-size: 10.5px; border: 2px solid #000; padding: 5px; text-transform: uppercase; background-color: #f5f5f5; }
                    
                    /* Tabelas de Itens */
                    table { width: 100%; border-collapse: collapse; }
                    table, th, td { border: 2px solid #000; }
                    th { font-size: 9px; font-weight: bold; padding: 5px; text-transform: uppercase; background: #f5f5f5; text-align: center; }
                    td { padding: 4px 6px; font-size: 9.5px; }
                    .componente-nome { font-weight: bold; }
                    .center { text-align: center; font-weight: bold; font-size: 11px; width: 30px; }
    
                    /* Diagrama Físico e Senha */
                    .box-imagens { border: 2px solid #000; border-top: none; padding: 6px; display: table; width: 100%; box-sizing: border-box; height: 95px; background: #fff; }
                    .img-cell { display: table-cell; width: 23%; vertical-align: middle; text-align: center; }
                    .img-placeholder { width: 58px; height: 80px; border: 1px dashed #555; display: inline-block; font-size: 7.5px; box-sizing: border-box; padding-top: 32px; color: #444; font-weight: bold; background: #fafafa; }
                    .senha-cell { display: table-cell; width: 31%; vertical-align: middle; text-align: center; padding-left: 5px; }
                    .padrao-senha { display: inline-grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-top: 5px; }
                    .ponto { width: 6px; height: 6px; background-color: #000; border-radius: 50%; }
                    
                    /* Termos e Condições Legais Completos */
                    .box-termos { border: 2px solid #000; border-top: none; padding: 6px 8px; text-align: justify; font-size: 8px; line-height: 1.25; box-sizing: border-box; background: #fff; }
                    
                    /* Campo de Observações */
                    .observacoes { border: 2px solid #000; margin-top: 5px; padding: 6px 8px; min-height: 50px; font-size: 10px; box-sizing: border-box; background: #fff; }
                    .observacoes strong { display: block; margin-bottom: 3px; font-weight: bold; }
    
                    /* Bloco do Rodapé Totalmente Selado e Fechado pelas Bordas */
                    .bloco-fechamento { width: 100%; border-collapse: collapse; margin-top: 5px; box-sizing: border-box; }
                    .bloco-fechamento td { padding: 0; border: 2px solid #000; }
                    .declaracao-celula { font-size: 9.5px; font-weight: bold; padding: 7px !important; text-align: center; background: #f5f5f5; border-bottom: 2px solid #000 !important; }
                    
                    .assinaturas-subgrid { display: table; width: 100%; table-layout: fixed; }
                    .box-assinatura { display: table-cell; width: 50%; padding: 30px 15px 12px 15px; text-align: center; font-size: 10px; font-weight: bold; background: #fff; }
                    .box-assinatura:first-child { border-right: 2px solid #000; }
                    .linha-traco { border-top: 1px solid #000; margin-bottom: 6px; width: 85%; margin-left: auto; margin-right: auto; }
                </style>
            </head>
            <body>
                <div class="header-loja">
                    <div class="logo-box" style="text-align: center; padding: 5px;">
                        <img src="${`${apiUrl}/store/photo/${store.imagem}`}" alt="${store.nome}" width="75" height="75" /></div>
                    <div class="info-loja">
                        <h1>${store.nome}</h1>
                        <p><strong>CNPJ:</strong> ${store.cnpj} | <strong>Whatsapp:</strong> ${store.whatsapp}</p>
                        <p><strong>Endereço:</strong> ${store.rua}, ${store.numero} - ${store.bairro}, ${store.cidade} - ${store.estado}, ${store.cep}</p>
                        <p><strong>E-mail:</strong> ${store.email}</p>
                    </div>
                    <div class="os-box">
                        <h2>ORDEM DE SERVIÇO</h2>
                        <div class="os-numero">#${this.state.os}</div>
                    </div>
                </div>
                
                <div class="info-cliente">
                    <div class="info-grid">
                        <div class="info-row">
                            <div class="info-cell" style="width: 65%;"><strong>CLIENTE:</strong> ${clienteSelecionado ? clienteSelecionado.nome : '___________________________________________'}</div>
                            <div class="info-cell" style="width: 35%;"><strong>DOCUMENTO:</strong> ${clienteSelecionado ? clienteSelecionado.documento : '_______________________'}</div>
                        </div>
                        <div class="info-row">
                            <div class="info-cell"><strong>APARELHO:</strong> ${aparelho || '___________________________________________'}</div>
                            <div class="info-cell"><strong>IMEI/SN:</strong> ${imei || '_______________________'}</div>
                        </div>
                    </div>
                </div>
    
                <div class="container-flex">
                    <div class="col-esquerda">
                        <div class="titulo-secao">Check List - Entrada</div>
                        <table>
                            <thead>
                                <tr>
                                    <th style="text-align: left;">Componentes</th>
                                    <th>Sim</th>
                                    <th>Não</th>
                                    <th>N/A</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${totalLinhas}
                            </tbody>
                        </table>
                    </div>
    
                    <div class="col-direita">
                        <div class="titulo-secao">Condições do Aparelho</div>
                        <div class="box-imagens">
                            <div class="img-cell"><div class="img-placeholder">FRENTE</div></div>
                            <div class="img-cell"><div class="img-placeholder">VERSO</div></div>
                            <div class="img-cell"><div class="img-placeholder">LATERAIS</div></div>
                            <div class="senha-cell">
                                <div style="font-size:7.5px; font-weight:bold; text-transform:uppercase;">Senha Padrão</div>
                                <div class="padrao-senha">
                                    <div class="ponto"></div><div class="ponto"></div><div class="ponto"></div>
                                    <div class="ponto"></div><div class="ponto"></div><div class="ponto"></div>
                                    <div class="ponto"></div><div class="ponto"></div><div class="ponto"></div>
                                </div>
                            </div>
                        </div>
    
                        <div class="titulo-secao" style="border-top: none;">Termos e Condições</div>
                        <div class="box-termos">
                            1. Em caso do equipamento apresentar algum defeito envolvendo componentes que não tenham sido relacionados e cobrados na ordem de serviço, só serão substituídos mediante o pagamento do referido conserto. 2.Aparelhos não retirados após 90 dias serão considerados como abandonados, sendo que a Suporte poderá dar-lhe outra destinação, inclusive para desmanche ou venda. 3. O cliente fica ciente que a Suporte não se responsabiliza pela integridade de mensagens, agenda, toques, créditos vencidos e qualquer informação contida no aparelho, sendo que sua cópia prévia é responsabilidade do cliente. 4. Fica ciente que poderão ser utilizadas peças recondicionadas para reparo (em casos específicos e componentes específicos) e que LIMPEZA DA PLACA PRINCIPAL DEVIDO A OXIDAÇÃO, BANHO QUÍMICO EM APARELHOS MOLHADOS OU EXPOSTOS A LÍQUIDOS, ATUALIZAÇÃO DE SOFTWARES, AJUSTE ELÉTRICO E RESSOLDAGEM NÃO POSSUEM GARANTIA DE SERVIÇO, pois tais procedimentos são apenas tentativas paliativas de reparo e poderão não solucionar os defeitos. Nestes casos o aparelho poderá não voltar a funcionar e não haverá ressarcimento dos valores pagos, em qualquer hipótese. 5. Problemas causados por instalação, revisão ou montagem incorreta do aparelho, por qualquer pessoa ou empresa não autorizada pela Suporte Smart perderá o direito a garantia. 6. Em caso de troca de tela, após a retirada do aparelho com check-list completo, em pleno funcionamento de todas as funções atestadas pelo cliente, não nos responsabilizamos por futuros problemas que possam a surgir não sejam relacionados a tela trocada, exemplo: Conector de carga, câmeras, auto falantes, bateria, vibra, botões, antenas e etc. 7. Na troca de tela dos iPhones 5, 5S, 6, 6Plus, 6S, 6S Plus, 7 e 7Plus, 8, 8Plus, X, XS, XS MAX, XR, 11, 11pro, 11pro MAX, 12, 12 mini, 12 pro, 12 pro MAX pode ocorrer deslocamento da tela em função do chassi dos referidos modelos entortarem facilmente devido ao material utilizado pelo fabricante. 8. O Cliente fica ciente de que o manuseio ou tentativa de reparo dos modelos iPhone 5S, 6, 6Plus, 6S, 6S Plus, 7 e 7Plus, 8, 8Plus, X, XS, XS MAX, XR, 11, 11pro, 11pro MAX, 12, 12 mini, 12 pro, 12 pro MAX ou outros aparelhos que possuem biometria, da linha Apple, pode perder essa função uma vez que é um sistema de impressão digital criptografada, que desconectado da placa não é possível recuperá-la. 9. Ao realizar os procedimentos padrões para abertura e conserto de aparelhos em que o risco de quebra da tela ou tampa traseira é iminente. O cliente fica ciente que em um caso de avaria dessas peças, terão de arcar com o valor da troca da mesma, não sendo, em nenhuma hipótese, responsabilidade da Suporte Smart a troca ou devolução de algum valor referente a esta peça. 10. Serviço de Banho Químico: caso o serviço de certo será cobrado valor integral, caso não de certo será cobrado 50% do valor. 11. O prazo de garantia é de 90 dias.
                        </div>
                    </div>
                </div>
    
                <div class="observacoes">
                    <strong>OBSERVAÇÕES / RELATO DO DEFEITO:</strong>
                </div>
    
                <table class="bloco-fechamento">
                    <tr>
                        <td class="declaracao-celula">
                            Estou ciente e afirmo que acompanhei os testes acima mencionados, ou a não realização pela impossibilidade da realização dos testes.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="assinaturas-subgrid">
                                <div class="box-assinatura">
                                    <div class="linha-traco"></div>
                                    Assinatura do Cliente (Entrada)
                                </div>
                                <div class="box-assinatura">
                                    <div class="linha-traco"></div>
                                    Data Prevista: ____/____/_______ às ____:____
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
    
                <script>
                    window.onload = function() {
                        window.print();
                        setTimeout(function() { window.close(); }, 500);
                    };
                </script>
            </body>
            </html>
        `);
        printWindow.document.close();
    };

    render() {
        const { checklist, enviando, clienteSelecionado, store } = this.state;
        if (this.state.loader) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <CircularProgress />
                </Box>
            )
        }
        return (
            <Box sx={{ p: 1 }}>
                <Grid container spacing={2}>

                    {/* SELEÇÃO DO CLIENTE */}
                    <Grid item size={{ xs: 12 }}>
                        <Paper variant="outlined" sx={{ p: 2, mb: 1, backgroundColor: '#fafafa' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1.5, textTransform: 'uppercase', color: '#555' }}>
                                    Identificação do Cliente
                                </Typography>
                                <Button
                                    variant="contained"
                                    startIcon={<PrintIcon />}
                                    color="primary"
                                    onClick={this.handlePrint}
                                    disabled={enviando}
                                >
                                    Imprimir
                                </Button>
                            </Box>


                            <Grid container spacing={2}>
                                <Grid item size={{ xs: 12, md: 4 }}>
                                    <TextField
                                        label="Nome"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        disabled
                                        value={this.state.clienteSelecionado.nome || ''}
                                    />
                                </Grid>
                                <Grid item size={{ xs: 12, md: 4 }}>
                                    <TextField
                                        label="Aparelho"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        disabled
                                        value={this.state.aparelho || ''}
                                    />
                                </Grid>
                                <Grid item size={{ xs: 12, md: 4 }}>
                                    <TextField
                                        label="IMEI"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        disabled
                                        value={this.state.imei || ''}
                                    />
                                </Grid>
                            </Grid>

                        </Paper>
                    </Grid>

                    {/* COLUNA ESQUERDA: TABELA */}
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <TableContainer component={Paper} variant="outlined">
                            <Box sx={{ backgroundColor: '#f5f5f5', padding: '10px', textAlign: 'center', borderBottom: '1px solid #ccc' }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                                    Check List - Entrada do Aparelho
                                </Typography>
                            </Box>

                            <Table size="small" aria-label="checklist entrada table">
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: '#fafafa' }}>
                                        <TableCell sx={{ fontWeight: 'bold' }}>COMPONENTES</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 'bold', width: '60px' }}>SIM</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 'bold', width: '60px' }}>NÃO</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 'bold', width: '60px' }}>N/A</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.componentes.map((item) => (
                                        <TableRow key={item} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell component="th" scope="row" sx={{ fontSize: '0.875rem', py: 0.5 }}>
                                                <strong>{item}</strong>
                                            </TableCell>

                                            <TableCell align="center" sx={{ py: 0 }}>
                                                <Checkbox
                                                    checked={checklist[item] === 'SIM'}
                                                    disabled
                                                    onChange={() => { }}
                                                    size="small"
                                                />
                                            </TableCell>

                                            <TableCell align="center" sx={{ py: 0 }}>
                                                <Checkbox
                                                    checked={checklist[item] === 'NAO'}
                                                    onChange={() => { }}
                                                    disabled
                                                    size="small"
                                                />
                                            </TableCell>

                                            <TableCell align="center" sx={{ py: 0 }}>
                                                <Checkbox
                                                    checked={checklist[item] === 'NA'}
                                                    onChange={() => { }}
                                                    disabled
                                                    size="small"
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>


                    <Grid item size={{ xs: 12, md: 6 }}>
                        <TableContainer component={Paper} variant="outlined" sx={{ height: '100%', minHeight: '500px' }}>
                            <Box sx={{ backgroundColor: '#f5f5f5', padding: '10px', textAlign: 'center', borderBottom: '1px solid #ccc' }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                                    Condições e termos de responsabilidade
                                </Typography>
                            </Box>
                            <Box sx={{ p: 1 }}>
                                <InspectorCelular />
                            </Box>
                        </TableContainer>
                    </Grid>
                </Grid>

            </Box>
        );
    }
}

export default WithRouter(ChecklistView);